"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicEffect = void 0;
var react_1 = require("react");
exports.useIsomorphicEffect = typeof document !== 'undefined' ? react_1.useLayoutEffect : react_1.useEffect;
